// Display formatting shared across pages (Indian locale, rupee amounts).

export function formatCurrency(value) {
  return `₹${Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}`;
}

// ₹1.2Cr / ₹3.4L / ₹5.6K for chart axes and labels.
export function compactCurrency(value) {
  const num = Number(value || 0);
  if (Math.abs(num) >= 10000000) return `₹${(num / 10000000).toFixed(1)}Cr`;
  if (Math.abs(num) >= 100000) return `₹${(num / 100000).toFixed(1)}L`;
  if (Math.abs(num) >= 1000) return `₹${(num / 1000).toFixed(1)}K`;
  return `₹${num.toFixed(0)}`;
}

export function formatPercent(value) {
  return `${Number(value || 0).toFixed(1)}%`;
}

export function formatDate(value) {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function shortLabel(value, maxLength = 24) {
  const label = String(value || "Unknown item").trim();
  if (label.length <= maxLength) return label;
  return `${label.slice(0, maxLength - 1)}...`;
}

export function getInitials(value) {
  return String(value || "WC")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join("") || "WC";
}

// "PENDING_CLEARANCE" -> "Pending Clearance"
export function prettyStatus(status) {
  return String(status || "Pending")
    .toLowerCase()
    .replace(/(^|_|\s)\w/g, (match) => match.toUpperCase().replace("_", " "));
}

// "↑ 12.5% vs yesterday" style note for a percentage change.
export function changeNote(value, label) {
  const numericValue = Number(value || 0);
  const arrow = numericValue > 0 ? "↑" : numericValue < 0 ? "↓" : "→";
  return `${arrow} ${formatPercent(Math.abs(numericValue))} ${label}`;
}

// CSS class for a percentage change: up / down / flat.
export function changeTone(value) {
  const numericValue = Number(value || 0);
  if (numericValue > 0) return "metric-note-up";
  if (numericValue < 0) return "metric-note-danger";
  return "metric-note-neutral";
}
